export default "__VITE_ASSET__Twn33Zkq__"